import { inject, Injectable } from '@angular/core';
import { LocalDataSource } from '@vdms-hq/shared';
import { catchError, EMPTY, from, map, of, switchMap } from 'rxjs';
import { FieldConfigId, FieldDefinitionModel, FieldsFetcherService } from '@vdms-hq/fields';
import { ClientAdminActionService, ClientAdminDataSourceService } from '@vdms-hq/client-admin-core';
import { AuthService } from '@vdms-hq/auth';

@Injectable({
  providedIn: 'root',
})
export class FieldsDataSource extends LocalDataSource<FieldDefinitionModel> {
  private adminFieldsConfigService = inject(FieldsFetcherService);
  public allData$ = this.adminFieldsConfigService
    .getConfiguration$('_admin-all-fields')
    .pipe(map((config) => config.system));

  #clientAdminDataSource = inject(ClientAdminDataSourceService);
  #clientAdminActionService = inject(ClientAdminActionService);
  #authService = inject(AuthService);

  constructor() {
    super({
      pageSizeOptions: [100, 200, 300],
      defaultPageSize: 100,
    });
    this.initialize();
  }

  save(id: FieldConfigId, value?: Partial<FieldDefinitionModel>) {
    const model = this.#clientAdminDataSource.currentAdminClient();
    if (!model) {
      return EMPTY;
    }

    if (value) {
      model.setFieldOverride(id, value);
    } else {
      model.removeFieldOverride(id);
    }
    // Pending until the save below succeeds; a blocked save leaves it for the other pages' Save.
    this.#clientAdminDataSource.markAsUnsaved();

    return this.#clientAdminActionService.save(model).pipe(
      switchMap((success) =>
        success
          ? from(this.#authService.refreshAuthMe()).pipe(
              map(() => true),
              catchError(() => of(true)),
            )
          : of(false),
      ),
    );
  }
}
